<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">基本资料</h3>
    </div>
    <div class="box-body">
      <div class="page-uinfo">
        <div class="column-item">
          <div class="header">
            <div class="title"><i class="el-icon-user"></i> 公司信息</div>
<!--            <div class="tools"><el-button type="text" @click="toEdit()" size="small"><i class="fa fa-edit"></i> 编辑</el-button></div>-->
          </div>
          <div class="body">
            <el-row class="row">
              <el-col :span="14"><lable>企业名称：</lable>{{ info.name }}</el-col>
              <el-col :span="10"><lable>所属行业：</lable>{{ info.industry }}</el-col>
            </el-row>
            <el-row class="row">
              <el-col :span="14"><lable>企业规模：</lable>{{ info.scale || '-'}}</el-col>
              <el-col :span="10"><lable>联系人：</lable>{{ info.contact || '-'}}</el-col>
            </el-row>
            <el-row class="row">
              <el-col :span="14"><lable>联系电话：</lable>{{ info.phone || '-'}}</el-col>
              <el-col :span="10"><lable>企业邮箱：</lable>{{ info.email || '-' }}</el-col>
            </el-row>
            <el-row class="row">
              <el-col :span="14"><lable>企业地址：</lable>{{ info.address }}</el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      info: {},
    }
  },
  computed: {
    ...mapGetters(['user', 'company']),
  },
  created() {
    this.getCompanyInfo()
  },
  methods: {
    getCompanyInfo() {
      console.info(123123)
      this.info = this.company
    },
    toEdit(){
    }
  }
}
</script>
<style lang="scss" scoped>
.page-uinfo{
  width:1000px;
  margin:0 auto;
  .column-item{
    .header{
      display: flex;
      justify-content: space-between;
      font-weight: 700;
      border-bottom: 1px solid #e9e9e8;
      align-items: center;
      margin:10px 0;
    }
    .body{
      padding: 20px;
      .row{
        margin-bottom: 20px;
        font-weight: 400;
        lable{
          font-weight: 700;
        }
      }

      .sec-item{
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .icon{
          font-size: 40px;
          color:#FF5C00;
          font-weight: 700;
          margin-right: 10px;
        }

        .title{
          font-weight: 700;
          margin: 0;
          .unset{
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color:#FF9900;
          }
        }
        .desc{
          font-size: 12px;
          color:#999;
          margin:2px 0;
        }

      }
    }

  }
}
</style>
